import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../HeaderNew/component";
import "./styles.scss";
import { SELLER_BY_SUBCATEGORY } from "../../api/apiList";
import API2 from "../../api/indexv2";
import { updateCartItem } from "../../slices/catalogSlice";
import EmptyPage from "../EmptyPage/component";
import { ToastContainer } from "react-toastify";
import NearbyStores from "../HomePageNew/near-by-store";
import Footer from "../../components/common/Footer";
import NoProductFound from "../EmptyPage/images/no-product-found.svg";
import Breadcrumb from "../../components/common/breadcrumb";
import Loader from "../../components/common/loader";
import MobileAddCart from "../../components/common/mobile-add-cart/index";

const CategorySection = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sellerData, setSellerData] = useState([]);
  const [loading, setLoadings] = useState(false);
  const cartItems = useSelector((s) => s.catalog.cartItems);
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const defaultLat = parseFloat(defaultAddress?.latitude);
  const defaultLon = parseFloat(defaultAddress?.longitude);
  const [isHeaderHide, setIsHeaderHide] = useState(false);
  const getQueryParams = (queryString) => {
    return new URLSearchParams(queryString);
  };
  const queryParams = getQueryParams(location.search);
  const categoryName = decodeURIComponent(queryParams.get("name"));
  const encodedValue = encodeURIComponent(categoryName);
  localStorage.setItem("slug", `/category?name=${encodedValue}`);

  useEffect(() => {
    const cartFromLocalStorage = JSON.parse(localStorage.getItem("cart")) || [];
    dispatch(updateCartItem(cartFromLocalStorage));
  }, [dispatch]);

  useEffect(() => {
    catalogs();
  }, [cartItems]);

  useEffect(() => {
    if (sellerData) {
      catalogs();
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsHeaderHide(true);
      } else {
        setIsHeaderHide(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sellerBySubcategory = async () => {
    try {
      const location = `${defaultLat},${defaultLon}`;
      setLoadings(true);
      const body = {
        subCategory: categoryName,
        location: location,
        areaCode: defaultAddress.zipcode,
      };
      const response = await API2.post(SELLER_BY_SUBCATEGORY, body);
      if (response.data) {
        let sellers = response.data.data;
        setSellerData(sellers);
        setLoadings(false);
        const category_data = { sellers: sellers, category: categoryName };
      }
    } catch (error) {
      console.error("Error fetching seller data:", error);
    }
  };

  useEffect(() => {
    sellerBySubcategory();
  }, []);

  const catalogs = (isFromScroll, page) => {
    if (!sellerData || !sellerData.length) {
      return;
    }
    // Update seller data based on cart items
    const updatedSellerData = sellerData.map((seller) => {
      const updatedCataloguesArr = seller.cataloguesArr.map((catalog) => {
        const cartItem = cartItems.find((item) => item._id === catalog._id);
        return cartItem
          ? { ...catalog, quantity: cartItem.quantity }
          : { ...catalog, quantity: 1 }; // Default to 1 if not in the cart
      });
      return { ...seller, cataloguesArr: updatedCataloguesArr };
    });
    setSellerData(updatedSellerData);
  };

  return (
    <>
      <ToastContainer
        autoClose={300}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Header hide={isHeaderHide} title={categoryName} />
      <div className="mobile-secondary-header-kl product-detail-mobile-header">
        <div className="mobile-secondary-header-inner-kl">
          <div className="mobile-secondary-header-title-kl">{categoryName}</div>
        </div>
      </div>
      <div className="category-container-kl">
        <Breadcrumb category={categoryName} />
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="page-header-bg-container-kl">
                <div className="page-header-bg-container-inner-kl">
                  <div className="page-header-location-kl">
                    <div className="page-header-location-title-kl">
                      {categoryName}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="category-inner-container-kl">
          {loading ? (
            <Loader />
          ) : sellerData?.length === 0 ? (
            <EmptyPage
              image={NoProductFound}
              EmptySubTitle="No Stores Found !"
              altText="Store Not Found"
            />
          ) : (
            <NearbyStores
              sellers={sellerData}
              navigate={navigate}
              categoryParam={categoryName}
            />
          )}
        </div>
      </div>
      <Footer />
      <MobileAddCart itemCount={cartItems?.length} />
    </>
  );
};

export default CategorySection;
